import MainInfoSection from './MainInfoSection';

export default MainInfoSection;
